import { string, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { m as CUSTOM_MIN_CHARACTERS } from '../../../validation-AjMAVn7m.js';

const initialValues = {
    search: '',
};

const getValidationSchema = (searchCharactersMinLength) => {
    const validationSchema = {
        search: string().trim().min(searchCharactersMinLength, CUSTOM_MIN_CHARACTERS),
    };
    return yupResolver(object().shape(validationSchema));
};

export { getValidationSchema, initialValues };
//# sourceMappingURL=index.js.map
